import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import { ChevronLeftOutline, ChevronRightOutline } from '@olist/design-system-icons';
import { PaginationButtonsEnum } from './interfaces.js';
import { PaginationListItem, PaginationButton } from './styles.js';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import '../Text/ParagraphLg/ParagraphLg.js';
import ParagraphMd from '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

function PaginationItem(_a) {
    var { item, currentPage, pageCount = 0, onPageChange, nextAriaLabel, pageAriaLabel, previousAriaLabel, disableLastPage, infiniteScroll } = _a, props = __rest(_a, ["item", "currentPage", "pageCount", "onPageChange", "nextAriaLabel", "pageAriaLabel", "previousAriaLabel", "disableLastPage", "infiniteScroll"]);
    const isEllipsis = item === PaginationButtonsEnum.ELLIPSIS;
    const isPrevious = item === PaginationButtonsEnum.PREVIOUS;
    const isNext = item === PaginationButtonsEnum.NEXT;
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === pageCount || (infiniteScroll && !(infiniteScroll === null || infiniteScroll === void 0 ? void 0 : infiniteScroll.next));
    const isCurrentPage = currentPage === item;
    const isButtonLastPage = item === pageCount;
    const isSpecialRange = pageCount === 5 || pageCount === 4;
    const isPenultimatePage = currentPage === pageCount - 1;
    const isInsideSpecialRange = isSpecialRange && item === pageCount - 1;
    const isAntipenultimatePage = currentPage === pageCount - 2;
    const isButtonDisabled = !infiniteScroll && !pageCount;
    const ariaLabel = isPrevious
        ? previousAriaLabel
        : isNext
            ? nextAriaLabel
            : `${pageAriaLabel} ${item}`;
    const handlePageChange = (e) => {
        if (!onPageChange) {
            return;
        }
        if (isPrevious) {
            onPageChange(currentPage - 1);
            return;
        }
        if (isNext) {
            onPageChange(currentPage + 1);
            return;
        }
        if (isEllipsis || currentPage === item) {
            e.preventDefault();
            return;
        }
        onPageChange(item);
        return;
    };
    const lastPageDisableCondition = disableLastPage && !isLastPage && !isPenultimatePage && isButtonLastPage;
    const penultimatePageDisableCondition = disableLastPage &&
        isInsideSpecialRange &&
        !isPenultimatePage &&
        !isAntipenultimatePage &&
        !isLastPage;
    const isButtonDisable = (isPrevious && isFirstPage) ||
        (isNext && isLastPage) ||
        lastPageDisableCondition ||
        penultimatePageDisableCondition ||
        isButtonDisabled;
    return (React.createElement(PaginationListItem, null,
        React.createElement(PaginationButton, Object.assign({}, props, { onClick: handlePageChange, notInteractive: isEllipsis, tabIndex: isEllipsis ? -1 : 0, selected: isCurrentPage, disabled: isButtonDisable, "aria-label": !isEllipsis ? ariaLabel : undefined, "aria-hidden": isEllipsis }),
            isPrevious && React.createElement(ChevronLeftOutline, null),
            !isPrevious && !isNext && (React.createElement(ParagraphMd, { bold: Boolean(isCurrentPage) }, item)),
            isNext && React.createElement(ChevronRightOutline, null))));
}

export { PaginationItem };
